import {
  isAptEnabled,
} from './auth';

const forceLogout = ({ basePath = '', aptEnabled } = {}) => {
  const {
    href,
    origin,
  } = window.location;
  // The current location we want to redirect the client back to after they enter their password
  const afterAuthContinueURL = encodeURIComponent(href);
  // Send the browser to the CIMA login screen after we log the user out
  const targetAuthQuery = new URLSearchParams({
    prompt: 'select_billing_account login',
    continue: href,
  }).toString();
  const isAptForceConnect = typeof aptEnabled === 'boolean'
    ? aptEnabled
    : isAptEnabled();
  const forceConnectPath = isAptForceConnect
    ? `/cotton/oauth/v1/force_connect?${targetAuthQuery}`
    : `/oauth/force_connect?continue=${afterAuthContinueURL}`;
  const forceConnectUrl = encodeURIComponent(`${origin}${basePath}${forceConnectPath}`);
  let clientId = 'my-account-web';
  if (window.MAW.env === 'local' || window.MAW.env === 'qa' || window.MAW.env === 'dev') {
    clientId = 'my-account-web-development';
  } else if (window.MAW.env === 'staging' || window.MAW.env === 'preprod') {
    clientId = 'my-account-web-preprod';
  }

  // Send the browser to log out
  window.location.replace(`https://oauth.xfinity.com/oauth/sp-logout?client_id=${clientId}&state=${forceConnectUrl}`);
};
export const cottonForceDisconnect = ({ basePath = '', aptEnabled } = {}) => {
  const {
    href,
    origin,
  } = window.location;
  // The current location we want to redirect the client back to after they enter their password.
  const afterAuthContinueURL = encodeURIComponent(href);
  const targetAuthQuery = new URLSearchParams({
    prompt: 'select_billing_account login',
    continue: href,
  }).toString();
  const isAptForceConnect = typeof aptEnabled === 'boolean'
    ? aptEnabled
    : isAptEnabled();
  const forceConnectPath = isAptForceConnect
    ? `/cotton/oauth/v1/force_connect?${targetAuthQuery}`
    : `/cotton/oauth/force_connect?continue=${afterAuthContinueURL}`;
  // Send the browser to the CIMA login screen after we destroy the session.
  const forceConnectUrl = encodeURIComponent(`${origin}${basePath}${forceConnectPath}`);
  // Send the browser to the cotton/oauth/disconnect endpoint to destroy the cotton session and
  // isAuth cookies.
  window.location.replace(`${basePath}/cotton/oauth/disconnect?continue=${forceConnectUrl}`);
};
export default forceLogout;
